var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DocusignThankYou',{attrs:{"loading":_vm.loadingSignComplete || !_vm.successfulResponse,"document-type":_vm.$route.query.type,"img":_vm.image,"support-number":_vm.theme().novatedBrand?.support?.phone,"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }